function toFarsi(number) {
    let input = [];
    let output = [];
    let sNumber = number.toString();
    for (let i = 0; i < sNumber.length; i += 1) {
        input.push(+sNumber. charAt(i));
    }
    input.forEach(number => output.push(numberConvertor(number)));
    return output.join('');
}
function numberConvertor (number) {
    switch (number) {
        case 1:
            return "۱";
        case 2:
            return "۲";
        case 3:
            return "۳";
        case 4:
            return "۴";
        case 5:
            return "۵";
        case 6:
            return "۶";
        case 7:
            return "۷";
        case 8:
            return "۸";
        case 9:
            return "۹"
        case 0:
            return "۰";
    }
}

export default toFarsi;